import { Select } from 'antd'
import { useEffect, useState } from 'react'
import { searchSiteEntries } from '../../../api'
import type { ContentEntry } from '../../../types'

/** Shared Entry search-select for collection_item/exhibition_ref/
 * research_ref (single) and featured_* (multi) blocks — resolves against
 * the real `ContentEntry` table via the same `searchSiteEntries` API the
 * Items/Exhibitions/Research management tabs already use (spec #12 —
 * never a Graphic-Editor-only content picker). */
export default function EntryPickerSelect({
  workspaceId,
  siteId,
  contentType,
  value,
  onChange,
  multiple = false,
  placeholder,
}: {
  workspaceId: string
  siteId: string
  contentType: 'item' | 'exhibition' | 'research'
  value: string | string[] | null
  onChange: (value: string | string[] | null) => void
  multiple?: boolean
  placeholder?: string
}) {
  const [options, setOptions] = useState<ContentEntry[]>([])
  const [loading, setLoading] = useState(false)

  const search = (q: string) => {
    setLoading(true)
    searchSiteEntries(workspaceId, siteId, { content_type: contentType, search: q || undefined, page: 1, page_size: 50 })
      .then((r) => setOptions(r.data.items))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    search('')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workspaceId, siteId, contentType])

  return (
    <Select
      mode={multiple ? 'multiple' : undefined}
      allowClear
      showSearch
      filterOption={false}
      loading={loading}
      value={value ?? undefined}
      onSearch={search}
      onChange={(v) => onChange((v as string | string[] | undefined) ?? null)}
      placeholder={placeholder || '搜索并选择…'}
      style={{ width: '100%' }}
      options={options.map((o) => ({ label: o.label, value: o.id }))}
    />
  )
}
